import React from 'react';
import classNames from 'classnames';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

const useStyles = makeStyles((theme: HCPTheme) => ({
  price: {
    marginRight: theme.spacing(1) / 2,
    fontWeight: (theme.typography.fontWeightBold as number) ?? 'normal',
    fontSize: theme.typography.h3.fontSize,
    lineHeight: 1,
  },
  faded: {
    color: theme.palette.grey[500],
    fontWeight: (theme.typography.fontWeightRegular as number) ?? 'normal',
    fontSize: theme.typography.caption.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
  },
}));

const PriceText = (props: { price: string; faded?: boolean }) => {
  const { price, faded = false } = props;
  const classes = useStyles();

  return (
    <Grid container justify="flex-end" alignItems={faded ? 'baseline' : 'flex-start'}>
      <Typography
        variant={!faded ? 'body1' : 'body2'}
        className={classNames(classes.price, { [classes.faded]: faded })}
        data-testid="price-amount"
      >
        {price}
      </Typography>
      <Typography variant="caption" className={classNames({ [classes.faded]: faded })} data-testid="price-cadence">
        per month
      </Typography>
    </Grid>
  );
};

export default PriceText;
